import {useEffect} from 'react';
import {IS_DEV_MODE} from '../config';
import {API} from './api.core';

export let api: API;

export const useApi = () => {
  if (!api) {
    api = new API();
  }

  useEffect(() => {
    if (IS_DEV_MODE) {
      // @ts-ignore
      window.__api = api;
    }
  }, []);

  return api;
};
